/**
 * Genel kayıt rotaları (WP 2.8 §28, K-14): yalnız izinli (tablosu ve liste sözleşmesi olan) tipler. Doğrudan URL'de
 * tip izin listesi denetlenir; bilinmeyen tip "bulunamadı" alır. Kişiler/Şirketler menüye bağlıdır (WP 2.9); Ürünler
 * menüsü WP 2.10 tamamlanana kadar "Yakında" kalır (rota doğrudan adresle erişilebilir, menüye bağlanmaz).
 */
import { M2_CORE_RECORD_TYPES, type M2CoreRecordType } from '@castinflow/shared';

/**
 * Genel kayıt sayfası olan tipler. v3.1 S10: konuşma (`conversation`) bir kayıt tipidir ama ekranı ekip gelen kutusudur
 * (`/inbox`); genel liste/kayıt sayfası yoktur.
 */
export type RoutableRecordType = Exclude<M2CoreRecordType, 'conversation'>;
export const ENABLED_RECORD_TYPES: readonly RoutableRecordType[] = M2_CORE_RECORD_TYPES.filter(
  (t): t is RoutableRecordType => t !== 'conversation',
);

export function enabledType(t: string | undefined): RoutableRecordType | null {
  return t !== undefined && (ENABLED_RECORD_TYPES as readonly string[]).includes(t)
    ? (t as RoutableRecordType)
    : null;
}

/** Ekip gelen kutusu (konuşma seçili açılabilir) */
export const inboxHref = (conversationId?: string) =>
  conversationId === undefined ? '/inbox' : `/inbox?konusma=${conversationId}`;

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isRecordId = (s: string | undefined): s is string =>
  s !== undefined && UUID_RE.test(s);

export const listHref = (type: string) => `/records/${type}`;
export const recordHref = (type: string, id: string) =>
  type === 'conversation' ? inboxHref(id) : `/records/${type}/${id}`;
